<template>
  <span>
    <img :src="statusImage" :alt="rowData.call_status" />
    {{ rowData.call_status }}
  </span>
</template>

<script>
export default {
  name: 'CallStatus',
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusImage() {
      switch (this.rowData.call_status) {
        case 'ANSWERED':
          return require('@/assets/images/icon-answered.svg')
        case 'NO ANSWER':
          return require('@/assets/images/icon-not_answered.svg')
        case 'FAILED':
          return require('@/assets/images/icon-failed.svg')
        case 'BUSY':
          return require('@/assets/images/icon-busy.svg')
        default:
          return require('@/assets/images/icon-answered.svg')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
img {
  max-width: 20px;
  height: auto;
  margin-right: 10px;
  position: absolute;
  left: 15px;
}
@media (max-width: 1365px) {
  img {
    position: static;
    left: unset;
  }
}
</style>
